export default {"src":"/_next/static/media/study-active-icon.82ce5776.svg","height":14,"width":14};